import { useState, useEffect } from 'react'
import PanelLeft from '../components/PanelLeft'
import PanelRight from '../components/PanelRight'

function Library({ onActionsChange }) {
  const [selectedSong, setSelectedSong] = useState('')
  const [languageToggle, setLanguageToggle] = useState({ v: true, v2: true })

  useEffect(() => {
    onActionsChange([
      { label: 'English', active: languageToggle.v, onClick: () => setLanguageToggle(t => ({ ...t, v: !t.v })) },
      { label: 'മലയാളം', active: languageToggle.v2, onClick: () => setLanguageToggle(t => ({ ...t, v2: !t.v2 })) },
    ])
  }, [languageToggle, onActionsChange])

  return (
    <div className="library">
      <PanelLeft setSelectedSong={setSelectedSong} />
      <PanelRight selectedSong={selectedSong} languageToggle={languageToggle} />
    </div>
  )
}

export default Library
